import { render, staticRenderFns } from "./LayoutError.vue?vue&type=template&id=44327326"
import script from "./LayoutError.vue?vue&type=script&lang=js"
export * from "./LayoutError.vue?vue&type=script&lang=js"
import style0 from "./LayoutError.vue?vue&type=style&index=0&id=44327326&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports